import BaseReducer from "shared/types/baseReducer";
import { LocalStorageKey } from "shared/utils/enums";
import LocalStorage from "shared/utils/storage/LocalStorage";
import Tokens from "shared/utils/storage/tokens";
import { Action, AuthActionType, AuthState, AuthDispatchInterface, AdminConsoleLoginResponse } from "./type.d";

export default class Reducer extends BaseReducer<AuthActionType> implements AuthDispatchInterface {
  static getInitialState(): AuthState {
    const token = Tokens.getInstance();
    let userDetail;
    try {
      userDetail = JSON.parse(LocalStorage.getItem(LocalStorageKey.USER_DETAIL));
    } catch (e) {}
    return {
      token: token.getAccessToken() || "",
      userDetail: userDetail
    };
  }

  static reducer(state: AuthState, action: AuthActionType): AuthState {
    switch (action.type) {
      case Action.USER_LOGIN:
        return { ...state, token: action.payload };
      case Action.USER_LOGOUT:
        return { ...state, token: "" };
      case Action.SAVE_USER_DETAIL:
        return { ...state, userDetail: action.payload };
    }
  }

  public loginAction(payload: string): void {
    return this.dispatch({ type: Action.USER_LOGIN, payload });
  }

  public logoutAction(): void {
    return this.dispatch({ type: Action.USER_LOGOUT });
  }

  public saveUserDetailAction(payload?: AdminConsoleLoginResponse | undefined): void {
    return this.dispatch({ type: Action.SAVE_USER_DETAIL, payload });
  }
}
